module.exports = __webpack_public_path__ + "img/ic_logo.042c4d59.png";